import React, {InputHTMLAttributes, useState} from 'react';
import {BaseInputProps} from '../..';

import {Container, Label, Input as StyledTextArea} from './styles';
import {useController, useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';

export type TextAreaProps<T = any> = InputHTMLAttributes<HTMLTextAreaElement> &
  BaseInputProps & {name: NestedKeys<T>; gridColumn?: number};

const TextArea: React.FC<TextAreaProps> = ({
  name,
  label,
  gridColumn,
  border,
  ...props
}) => {
  const {control} = useFormContext();
  const {field} = useController({control, name});
  const [focused, setFocused] = useState(false);

  return (
    <Container {...{gridColumn, border, focused}}>
      <Label>{label}</Label>
      <StyledTextArea
        {...{...props, ...field, value: field.value ?? ''}}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </Container>
  );
};

export default TextArea;
